/* eslint-disable import/no-unused-modules */
import React from 'react'
import HereRouteMap from '../HereMaps/HereRouteMap'

const DirectionsMap = React.memo(function DirectionsMap(props) {
  return <HereRouteMap {...props} />
})

export default DirectionsMap
